/* global __DivvyEnvironment */
import { useEffect } from 'react'
import axios from 'axios'

import { getTankUrl } from '@sputnik/utils/billUtils'

export const POLL_TIME = 5 * 1000 * 60

export const useKeepNeoSessionAlive = (bdcOrgId) => {
  const pingNeoSession = async (bdcOrgId) => {
    const tankUrl = getTankUrl(bdcOrgId)
    const endpoint = __DivvyEnvironment?.BILL_GATEWAY_URL ?? tankUrl
    if (!endpoint) return false
    try {
      const resp = await axios.post(endpoint, '{"query":"query Query { currentTime }","operationName":"Query"}', {
        headers: {
          'content-type': 'application/json',
        },
        withCredentials: true,
      })
      // BDC_1109 is returned when the session is invalid
      return !resp?.data?.errors?.some((err) => err?.extensions?.code === 'BDC_1109')
    } catch {
      return false
    }
  }

  useEffect(() => {
    if (!bdcOrgId) return
    let id
    pingNeoSession(bdcOrgId).then((hasNeoSession) => {
      if (hasNeoSession) {
        id = setInterval(() => pingNeoSession(bdcOrgId), POLL_TIME)
      }
    })
    return () => {
      clearInterval(id)
    }
  }, [bdcOrgId])
}
